// Imports: local files.
import {
  GET_ALL_MUNICIPALITIES_START,
  GET_ALL_MUNICIPALITIES_SUCCESS,
  GET_ALL_MUNICIPALITIES_FAILED,
  GET_ALL_MUNICIPALITIES_RESET,
  GET_ONE_MUNICIPALITY_START,
  GET_ONE_MUNICIPALITY_SUCCESS,
  GET_ONE_MUNICIPALITY_FAILED,
  GET_ONE_MUNICIPALITY_RESET,
  CREATE_MUNICIPALITY_START,
  CREATE_MUNICIPALITY_SUCCESS,
  CREATE_MUNICIPALITY_FAILED,
  CREATE_MUNICIPALITY_RESET,
  UPDATE_ONE_MUNICIPALITY_START,
  UPDATE_ONE_MUNICIPALITY_SUCCESS,
  UPDATE_ONE_MUNICIPALITY_FAILED,
  UPDATE_ONE_MUNICIPALITY_RESET,
  DELETE_ONE_MUNICIPALITY_START,
  DELETE_ONE_MUNICIPALITY_SUCCESS,
  DELETE_ONE_MUNICIPALITY_FAILED,
  DELETE_ONE_MUNICIPALITY_RESET,
} from '../actions/actions';

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};
const initialState = {
  getAll: initialLoadingState,
  getOne: initialLoadingState,
  create: initialLoadingState,
  updateOne: initialLoadingState,
  deleteOne: initialLoadingState,
};

const municipalitiesReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get All Municipalities
     * =======================================================================
     */
    case GET_ALL_MUNICIPALITIES_START:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_MUNICIPALITIES_SUCCESS:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_MUNICIPALITIES_FAILED:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_MUNICIPALITIES_RESET:
      return { ...state, getAll: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get One Municipality
     * =======================================================================
     */
    case GET_ONE_MUNICIPALITY_START:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_MUNICIPALITY_SUCCESS:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_MUNICIPALITY_FAILED:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_MUNICIPALITY_RESET:
      return { ...state, getOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Create New Municipality
     * =======================================================================
     */
    case CREATE_MUNICIPALITY_START:
      return { ...state, create: { ...action.payload } };
    case CREATE_MUNICIPALITY_SUCCESS:
      return { ...state, create: { ...action.payload } };
    case CREATE_MUNICIPALITY_FAILED:
      return { ...state, create: { ...action.payload } };
    case CREATE_MUNICIPALITY_RESET:
      return { ...state, create: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Update One Municipality
     * =======================================================================
     */
    case UPDATE_ONE_MUNICIPALITY_START:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_MUNICIPALITY_SUCCESS:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_MUNICIPALITY_FAILED:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_MUNICIPALITY_RESET:
      return { ...state, updateOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Delete One Municipality
     * =======================================================================
     */
    case DELETE_ONE_MUNICIPALITY_START:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_MUNICIPALITY_SUCCESS:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_MUNICIPALITY_FAILED:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_MUNICIPALITY_RESET:
      return { ...state, deleteOne: { ...initialLoadingState } };
    default:
      return state;
  }
};

export default municipalitiesReducer;
